import { InternalRefetchQueryDescriptor } from '@apollo/client';
import { MutationHookOptions } from '@apollo/client/react';
import GET_CLASSROOM from 'graph/classroom/get-classroom-query';
import GET_CLASSROOMS_MANAGEMENT_QUERY from 'graph/classroom/get-classrooms-management-query';
import GET_USER_CLASSROOMS from 'graph/classroom/get-user-classrooms-query';

const getClassroomsMutationCacheUpdate = (
  userId: number,
  adminConsole: boolean = false
): MutationHookOptions => {
  // Mutations made from the Admin Console will use a different refetch query.
  const refetchQueries: InternalRefetchQueryDescriptor[] = adminConsole
    ? [{ query: GET_CLASSROOMS_MANAGEMENT_QUERY }]
    : [{ query: GET_USER_CLASSROOMS, variables: { userId } }];

  return { refetchQueries };
};

const getClassroomMutationCacheUpdate = (
  classroomId: number,
  adminConsole?: boolean
): MutationHookOptions => {
  // Mutations made from the Admin Console will use a different refetch query.
  const refetchQueries: InternalRefetchQueryDescriptor[] = adminConsole
    ? [{ query: GET_CLASSROOMS_MANAGEMENT_QUERY }]
    : [{ query: GET_CLASSROOM, variables: { id: classroomId } }];

  return { refetchQueries };
};

export { getClassroomsMutationCacheUpdate, getClassroomMutationCacheUpdate };
